import React, { FC } from 'react'
import { CMSStaticSection } from './../../../models'
import { Col, Row } from 'antd'
import { JCMSStaticBanner } from '../JCMSStaticBanner'
import './JCMSStaticContent.scss'
import { JCMSStaticSlider } from '../JCMSStaticSlider/JCMSStaticSlider'
import { JSection } from '../../../JSection'
import { JCMSStaticHowTo } from '../JCMSStaticHowTo'
import { JCMSStaticFaqTemplate } from '../JCMSStaticFaqTemplate'
import {useJCommonContext} from "../../../JCommonProvider";
import {getNavPathFromType} from "../../../lib";
export interface JCMSStaticContentProps extends CMSStaticSection.Content { }

export const JCMSStaticContent: FC<JCMSStaticContentProps> = props => {
    if (!props.enabled) return <></>
    const {navigate} = useJCommonContext();

    return (
        <Row className='jcms-static-section'>
            <Col span={24}>
                <JSection {...props}>
                    <Row>
                        {
                            props.sections?.map((section, i) => {
                                const onCLickInCard = (section?.options as any)?.onClickInCta;
                                const scope = (section?.options as any)?.scope;
                                return(
                                    <Col
                                        span={24}
                                        key={i}
                                        className={`jcms-static-section-section ${onCLickInCard ? 'pointer': ''}`}
                                        onClick={()=> onCLickInCard && navigate(getNavPathFromType(scope))}>
                                        {
                                            (() => {
                                                if (CMSStaticSection.isSlider(section)) {
                                                    return <JCMSStaticSlider {...section} />
                                                } else if (CMSStaticSection.isBanner(section)) {
                                                    return <JCMSStaticBanner {...section} />
                                                } else if (CMSStaticSection.isStaticContent(section)) {
                                                    return <JCMSStaticContent {...section} />
                                                } else if (CMSStaticSection.isHowTo(section)) {
                                                    return <JCMSStaticHowTo {...section} />
                                                } else if (CMSStaticSection.isFaqTemplate(section)) {
                                                    return <JCMSStaticFaqTemplate {...section} />
                                                }
                                                return <span></span>
                                            })()
                                        }
                                    </Col>
                                )
                            })
                        }

                    </Row>

                </JSection>
            </Col>
        </Row>
    )
}